import { createBrowserRouter, createHashRouter } from "react-router-dom";

// Root App with providers
import AppProviders from "@/AppProviders";

// Layouts
import Layout from "@/layouts/Layout";
import DashboardLayout from "@/components/layouts/dashboard-layout";

// Feature pages
import {
  LoginPage,
  RegisterPage,
  PasswordRecoveryPage,
  VerificationCodePage,
  ChangePasswordPage,
} from "@/features/auth";

import {
  DashboardPage,
  CampaignsListPage,
  AddCampaignPage,
  CampaignDetailsPage,
  CommandsListPage,
  AddCommandPage,
  CommandDetailsPage,
  EnrollmentsListPage,
  EnrollmentDetailsPage,
  LoopsListPage,
  LoopDetailsPage,
  UsersListPage,
  ProfilePage,
  UpdateCampagnePage,
  UpdateCommandPage,
  ProfileNotifications,
} from "@/features/dashboard";

import {
  HomePage,
  ServicesPage,
  NewsPage,
  AnalyticsPage,
  FaqPage,
  PublicEnrolementsPage,
} from "@/features/public-pages";

// Remaining pages that need to be migrated
import InscriptionGoogle from "@/pages/inscription-google";
import NotFoundPage from "@/pages/NotFoundPage";
import UserDetailsPage from "@/features/dashboard/users/UserDetailsPage";

// Routes configuration
export const router = createHashRouter([
  {
    path: "/",
    element: <AppProviders />,
    children: [
      {
        path: "/",
        element: <Layout />,
        children: [
          {
            index: true,
            element: <HomePage />,
          },
          {
            path: "services",
            element: <ServicesPage />,
          },
          {
            path: "actu",
            element: <NewsPage />,
          },
          {
            path: "faq",
            element: <FaqPage />,
          },
          // Auth routes
          {
            path: "connexion",
            element: <LoginPage />,
          },
          {
            path: "inscription",
            element: <RegisterPage />,
          },
          {
            path: "inscription-google",
            element: <InscriptionGoogle />,
          },
          {
            path: "chiffres-analyses",
            element: <AnalyticsPage />,
          },
          {
            path: "recuperation-acces",
            element: <PasswordRecoveryPage />,
          },
          {
            path: "changer/mot-de-passe/:token",
            element: <ChangePasswordPage />,
          },
          {
            path: "verification-code",
            element: <VerificationCodePage />,
          },

          {
            path: "enrolements/:matricule",
            element: <PublicEnrolementsPage />,
          },
        ],
      },
      {
        path: "/",
        element: <DashboardLayout />,
        children: [
          {
            path: "dashboard",
            element: <DashboardPage />,
          },

          {
            path: "dashboard/campagnes",
            element: <CampaignsListPage />,
          },
          {
            path: "dashboard/campagnes/add",
            element: <AddCampaignPage />,
          },
          {
            path: "dashboard/campagnes/:reference",
            element: <CampaignDetailsPage />,
          },
          {
            path: "dashboard/campagnes/edit/:reference",
            element: <UpdateCampagnePage />,
          },
          {
            path: "dashboard/commandes",
            element: <CommandsListPage />,
          },
          {
            path: "dashboard/commandes/add",
            element: <AddCommandPage />,
          },
          {
            path: "dashboard/commandes/:reference",
            element: <CommandDetailsPage />,
          },
          {
            path: "dashboard/commandes/edit/:reference",
            element: <UpdateCommandPage />,
          },
          {
            path: "dashboard/enrolements",
            element: <EnrollmentsListPage />,
          },
          {
            path: "dashboard/enrolements/:matricule",
            element: <EnrollmentDetailsPage />,
          },
          {
            path: "dashboard/boucles",
            element: <LoopsListPage />,
          },
          {
            path: "dashboard/boucle/:id",
            element: <LoopDetailsPage />,
          },
          {
            path: "dashboard/users",
            element: <UsersListPage />,
          },
          {
            path: "dashboard/users/:matricule",
            element: <UserDetailsPage />,
          },
          {
            path: "dashboard/profil",
            element: <ProfilePage />,
          },
          {
            path: "dashboard/profil/notifications",
            element: <ProfileNotifications />,
          },
        ],
      },
    ],
    errorElement: <NotFoundPage />,
  },
]);
